export enum Operator {
  Equal = 0,
  NotEqual = 1,
  LessThan = 2,
  LessThanEqual = 3,
  GreaterThan = 4,
  GreaterThanEqual = 5,
  Startswith = 6,
  Endswith = 7,
  Contains = 8,
  Doesnotcontain = 9,
  IsNull = 10,
  In = 11,
}

export enum Logic {
  And = 0,
  Or = 1,
}

export enum Direction {
  asc = 0,
  desc = 1,
}

export const Pagination = {
  PageStart: 1,
  PageSize: 10,
};

export const Model = {
  PaginationFilter: {
    PageNumber: Pagination.PageStart,
    PageSize: Pagination.PageSize,
  },
  Sort: [
    {
      Field: 'CreationDate',
      Dir: Direction.asc,
    },
  ],
  Filter: {
    Field: null,
    Operator: Operator.Equal,
    Value: null,
    Logic: Logic.And,
    Filters: [
      {
        Field: 'colNumber',
        Operator: Operator.Equal,
        Value: '3',
        Logic: Logic.And,
        Filters: null,
      },
      {
        Field: 'colText',
        Operator: Operator.Contains,
        Value: 'aa',
        Logic: Logic.And,
        Filters: null,
      },
      {
        Field: 'colDateFrom',
        Operator: Operator.GreaterThanEqual,
        Value: '2023-12-06 00:00:00.000',
        Logic: Logic.And,
        Filters: null,
      },
      {
        Field: 'colDateTo',
        Operator: Operator.LessThanEqual,
        Value: '2023-12-18 23:59:59.000',
        Logic: Logic.And,
        Filters: null,
      },
    ],
  },
  SearchString: null,
};
